export default {
  data () {
    return {
      software: []
    }
  },
  computed: {
    flattenedSoftware () {
      const ret = []
      this.software.forEach((item) => {
        if (item.IsPublic) {
          if (item.VersionedResources.length) {
            const versionedResources = []
            item.VersionedResources.forEach((res) => {
              const versionPart = res.MajorVersion + '.' + res.MinorVersion + '.' + res.ReleaseVersion + '.' + res.BuildVersion
              versionedResources.push({
                name: item.ResourceDescription,
                versionPart,
                file: { data: { attributes: { url: res.DownloadURL } } },
                externalIconUrl: item.ImageURL ? item.ImageURL : '?',
                publishDate: res.CreationDate,
                releaseNotesUrl: res.ReleaseNotesURL,
                isRelease: item.Level === 'Release',
                isLatest: false,
                isLegacy: item.IsLegacy
              })
            })
            /* sorting now happening on the server (Simon)
            versionedResources.sort((a, b) => {
              return new Date(b.publishDate) - new Date(a.publishDate)
            })
            */
            versionedResources[0].isLatest = true
            ret.push(...versionedResources)
          }
          item.UnversionedResources.forEach((res) => {
            ret.push({
              name: item.ResourceDescription,
              file: { data: { attributes: { url: res.DownloadURL } } },
              externalIconUrl: item.ImageURL ? item.ImageURL : '?',
              releaseNotesUrl: res.ReleaseNotesURL,
              isRelease: item.Level === 'Release',
              isLatest: true,
              isLegacy: item.IsLegacy
            })
          })
        }
      })
      return ret
    }
  }
}
